export enum MasterType {
  WEB = 'web',
  TERMINAL = 'terminal',
}
